<template>
  <div>
    <template v-if="isShopsSearch">
      <el-select-shop
        v-if="displayItems.length"
        class="search-select-shop"
        :value="value"
        :options="displayItems"
        v-bind="attrs"
        @shop-change="shopChange"
      />
    </template>
    <template v-else-if="['shopSource', 'shopSources', 'shopName', 'shopId', 'onPublishShopIds', 'noPublishShopIds', 'shopIds','platformData','notPlatformData'].includes(propKey)">
      <el-select
        class="search-select"
        :value="value"
        :multiple="attrs.multiple"
        collapse-tags
        clearable
        v-loadMore="asyncLoadMore"
        @change="changeHandle"
        @focus="focusHandle"
        v-bind="isAsync ? {
          ...attrs,
          filterable: true,
          remote: true,
          'remote-method': remoteMethod,
          ...(asyncOptions.attrs || {})
        } : attrs">
        <el-option
          v-for="(item,index) in displayItems"
          :key="index"
          :label="item[itemLabelKey]"
          :disabled="mutexPropVal ? mutexPropVal === item[itemValueKey] : false"
          v-bind="itemValueSelf ? {
            value: item
          } : {
            value: item[itemValueKey]
          }">
         <div class="image-slot">
            <el-image style="height: 18px; margin-right:5px" :src="item.icon" v-if="item.icon"></el-image>
            <span>{{item[itemLabelKey]}}</span>
         </div>
        </el-option>
      </el-select>
    </template>
    <template v-else>
      <el-select
        class="search-select"
        :value="value"
        :multiple="attrs.multiple"
        :clearable="attrs.clearable === undefined ? true : attrs.clearable"
        collapse-tags
        v-loadMore="asyncLoadMore"
        @change="changeHandle"
        @focus="focusHandle"
        @clear="clearHandle"
        @remove-tag="clearHandle"
        v-bind="isAsync ? {
          ...attrs,
          clearable: attrs.clearable === undefined ? true : attrs.clearable,
          filterable: true,
          remote: true,
          'remote-method': remoteMethod,
          ...(asyncOptions.attrs || {})
        } : attrs">
        <el-option
          v-for="(item, index) in displayItems"
          :key="index"
          :label="item[itemLabelKey]"
          :disabled="mutexPropVal ? mutexPropVal === item[itemValueKey] : false"
          v-bind="itemValueSelf ? {
            value: item
          } : {
            value: item[itemValueKey]
          }">
        </el-option>
      </el-select>
    </template>
  </div>
</template>

<script>
export default {
  name: 'search-select',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: [String, Number, Object, Array],
    items: {
      type: Array,
      default() {
        return []
      }
    },
    asyncItems:{
      type: Array,
      default() {
        return []
      }
    },
    itemValueSelf: {
      type: Boolean,
      default: false
    },
    itemLabelKey: {
      type: String,
      default: 'label'
    },
    itemValueKey: {
      type: String,
      default: 'value'
    },
    attrs: {
      type: Object,
      default() {
        return {}
      }
    },
    isShopsSearch: {
      type: Boolean,
      default: false
    },
    propKey: {
      type: String,
      default: ''
    },
    // 是否异步请求数据
    isAsync: {
      type: Boolean,
      default: false
    },
    // 异步请求的一些设置
    asyncOptions: {
      type: Object,
      default() {
        return {}
      }
    },
    // 选项变更后是否触发查询
    isSearch: {
      type: Boolean,
      default: true
    },
    mutexPropVal: [String, Number, Object, Array]
  },
  directives: {
    loadMore: {
      bind(el, binding) {
        const selectDom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        selectDom.addEventListener('scroll', function () {
          // 判断滚动到底部
          const flag = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (flag) {
            binding.value();
          }
        })
      }
    }
  },
  data() {
    return {
      page: {
        pageNo: 1
      },
      asyncIsNoMore: false,
      isOptionSelected: false, // 添加一个标记，用于判断是否刚刚选中了选项
    }
  },
  computed: {
    displayItems() {
      return this.isAsync ? this.asyncItems : this.items || []
    }
  },
  methods: {
    changeHandle(v) {
      this.$emit('change', v)
      this.$emit('changeVal', v)
      this.isSearch && this.$emit('search')
      if(this.isAsync && this.propKey === 'staffIds') {
        this.isOptionSelected = true // 选中选项后设置标记
      }
    },
    shopChange(val) {
      if(this.attrs.multiple) {
        val = val.filter(Boolean).map(item => item.userId)
      } else {
        val = val?.userId || ''
      }
      this.changeHandle(val)
    },
    focusHandle() {
      if (!this.isAsync) return;
      if (this.asyncOptions.resetOnFoucus) {
        this.page.pageNo = 1
        this.asyncItems = []
        this.asyncFetchItems()
      } else {
        if (!this.asyncItems.length) {
          this.asyncFetchItems()
        }
      }
    },
    asyncLoadMore() {
      this.asyncOptions.isLoadMore && this.asyncFetchItems()
    },
    async asyncFetchItems(queryText = '') {
      if (!this.asyncOptions.queryFn) {
        throw Error('asyncOptions.queryFn缺少，请提供')
      }
      if (this.asyncIsNoMore) return;

      const _params = this.asyncOptions.formatQueryParams ? this.asyncOptions.formatQueryParams({
        pageNo: this.page.pageNo,
        queryText
      }) : {
        pageNo: this.page.pageNo,
        queryType: 'name',
        queryText
      }

      const res = await this.asyncOptions.queryFn(_params);
      if(!res) return;
      this.asyncItems = this.asyncOptions.formatRespData ? this.asyncOptions.formatRespData({
        resData: res.list,
        currData: this.asyncItems
      }) : [...this.asyncItems, ...res.list];

      this.asyncIsNoMore = this.asyncOptions.isNoMore ? this.asyncOptions.isNoMore({
        res: res,
        currPage: this.page
      }) : (() => {
        const total = res.total || 1;
        const pageSize = res.page.pageSize;
        const pages =  total % pageSize == 0 ? total / pageSize : total / pageSize + 1;
        return this.page.pageNo + 1 > pages
      })()

      !this.asyncIsNoMore && (this.page.pageNo += 1)
    },
    remoteMethod(query) {
       // 异步查询中，如果是选中选项后的查询，则不执行空查询操作
       if (this.isOptionSelected) {
        this.isOptionSelected = false // 重置标记
        return;
      }

      this.page.pageNo = 1;
      if(query !== '') {
        this.loading = true;
        this.asyncFetchItems(query)
      } else {
        this.asyncFetchItems()
      }
    },
    // 添加清除事件处理方法
    clearHandle(removedTag) {
      if(this.isAsync && this.propKey ==='staffIds') {
        this.isOptionSelected = false;
        this.asyncFetchItems();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-select {
  width: 160px;
  ::v-deep .el-select__tags{
    max-width: 150px !important;
  }
}
.search-select-shop {
  ::v-deep .el-icon-search{
    right: 20px;
  }
}

.image-slot{
  display: flex;
  align-items: center;
}
</style>